// extracted by mini-css-extract-plugin
module.exports = {"icon":"SortButton_icon__SRSDb","iconReversed":"SortButton_iconReversed__gaT6U"};